import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "./CorporateDropDown.css";

export default function CorporateDropDown({
  corp,
  setSelectedCorp,
  rcorp,
}) {

  return (
    <div className="corporate-drop">
    <Autocomplete
      ListboxProps={{ style: { maxHeight: "15rem" } }}
      id="corporate-drop-down"
      sx={{ width: 200 }}
      options={corp}
      autoHighlight
      getOptionLabel={(option) => option}
      value={rcorp}
      size="small"
      onInputChange={(event, newInputValue) => {
        setSelectedCorp(newInputValue);
      }}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": {  flexShrink: 0 } }}
          {...props}
        >
          {option}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Corporate"
          variant="standard"
        />
      )}
    />
  
  </div>);
}
